import { useEffect, useState } from "react"
import { getDirectorName } from "lacinetek-common/src/models/product"
import image, { PRODUCT_PHOTOGRAMME } from "lacinetek-common/src/images"

import { FETCH_BUNDLES } from "lib/graphql"
import { useTranslation } from "lib/i18n/translation"
import { useCountry } from "lib/country"
import { getBundles } from "lib/bundle-fetcher"

import Query from "components/common/gql-query"
import { Slider } from "components/common"
import BundleAccessLink from "components/common/bundle-access-link"
import SkeletonLink from "components/common/skeleton-link"
import Image from "components/common/image"

const PackBundleProduct = ({ product, loading }) => {
	const { c } = useTranslation("common")
	const director = getDirectorName(product)

	return (
		<div className="slide-content">
			<SkeletonLink href="/film/[id]" as={`/film/${product.linkRewrite}`}>
				<a title={c("see-single-film")} className="film-link">
					<figure className={`cover ${loading ? "skeleton" : ""}`}>
						<picture>
							<Image
								src={loading ? '/static/images/default_movie.png' : image(product, PRODUCT_PHOTOGRAMME)}
								alt={product.name}
							/>
						</picture>
					</figure>
					<div className="infos">
						<h3 className="title">{product.name}</h3>
						&nbsp;
						{director && (
							<span className="director">{c("by")} {director}</span>
						)}
					</div>
				</a>
			</SkeletonLink>
		</div>
	)
}

const PackBundle = ({ bundle }) => {
	const { current, country } = useCountry()

	const [loading, setLoading] = useState(true)
	const [data, setData] = useState([])

	useEffect(() => {
		if (!bundle) return
		setLoading(true)
		getBundles([bundle.id], current, country.isoCode)
			.then(result => {
				setData(result[0])
				setLoading(false)
			})
			.catch(e => { console.log(e) })
	}, [current, bundle])

	if (
		!bundle
		|| loading
		|| !data?.available
	) {
		return null
	}

	const products = bundle.extension.products.items

	return (
		<section className="grey short block">
			<div className="section-title splitted">
				<h2 className="red">{bundle.name}</h2>
				<BundleAccessLink
					bundle={bundle}
					available={data?.available}
				/>
			</div>
			<Slider
				slides={products}
				slideComponent={PackBundleProduct}
				loading={loading}
				className="films inline"
				slidePropKey="product"
			/>
		</section>
	)
}

const Bundle = ({ film, goTo, loading }) => (
	<Query
		query={FETCH_BUNDLES}
		options={{
			variables: {
				query: "type:BUNDLE AND extension.bundle.products.id:" + film.id
			}
		}}
	>
		{({ cms }) => (
			<PackBundle
				film={film}
				goTo={goTo}
				loading={loading}
				bundle={cms.products.items[0]}
			/>
		)}
	</Query>
)

export default Bundle
